var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6501 14.4748C13.5626 14.4623 13.4501 14.4623 13.3501 14.4748C11.1501 14.3998 9.40002 12.5998 9.40002 10.3873C9.40002 8.12484 11.2251 6.28735 13.5001 6.28735C15.7626 6.28735 17.6001 8.12484 17.6001 10.3873C17.5876 12.5998 15.8501 14.3998 13.6501 14.4748Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9248 22.725C19.6998 24.7625 16.7498 26 13.4998 26C10.2498 26 7.29977 24.7625 5.07477 22.725C5.19977 21.55 5.94977 20.4 7.28727 19.5C10.7123 17.225 16.3123 17.225 19.7123 19.5C21.0498 20.4 21.7998 21.55 21.9248 22.725Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25.9999C20.4035 25.9999 26 20.4034 26 13.4999C26 6.59641 20.4035 1 13.5 1C6.59644 1 1 6.59641 1 13.4999C1 20.4034 6.59644 25.9999 13.5 25.9999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d44b14e5991521a45a1df9e041bf39e8.svg";
export { ForwardRef as ReactComponent };